import { render, staticRenderFns } from "./curriculos.vue?vue&type=template&id=3933a836&scoped=true&"
import script from "./curriculos.vue?vue&type=script&lang=js&"
export * from "./curriculos.vue?vue&type=script&lang=js&"
import style0 from "./curriculos.vue?vue&type=style&index=0&id=3933a836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3933a836",
  null
  
)

export default component.exports